export interface DriverProfile {
  id: string;
  staffName: string;
  role: string;
  status: 'Active' | 'Inactive' | 'Suspended';
  territory: string;
}

export interface PersonalInfo {
  staffName: string;
  employeeId: string;
  role: string;
  assignedTerritory: string;
}

export interface ContactInfo {
  email: string;
  phone: string;
  department: string;
}

export interface NotificationPreference {
  id: string;
  label: string;
  enabled: boolean;
}

export interface SecurityOption {
  id: string;
  label: string;
}

export interface SettingsItem {
  id: string;
  icon: 'bell' | 'globe' | 'wifi' | 'gear';
  title: string;
  subtitle: string;
}

export const defaultNotificationPreferences: NotificationPreference[] = [
  { id: 'route-assignment', label: 'Route Assignment', enabled: true },
  { id: 'delivery-schedule', label: 'Delivery Schedule Changes', enabled: true },
  { id: 'payment-collection', label: 'Payment Collection Alerts', enabled: true },
  { id: 'failed-delivery', label: 'Failed Delivery Notices', enabled: true },
  { id: 'system-updates', label: 'System Updates', enabled: false },
];

export const defaultSecurityOptions: SecurityOption[] = [
  { id: 'change-password', label: 'Change Password' },
];

export const defaultSettingsItems: SettingsItem[] = [
  { id: 'notifications', icon: 'bell', title: 'Notifications', subtitle: 'Manage notification preferences' },
  { id: 'language', icon: 'globe', title: 'Language', subtitle: 'English (US)' },
  { id: 'offline-mode', icon: 'wifi', title: 'Offline Mode', subtitle: 'Sync when online' },
  { id: 'general', icon: 'gear', title: 'General Settings', subtitle: 'App preferences and defaults' },
];
